import { httpGet } from "@/api/connection";
import { EvidenceProgress } from "./evidence-progress.types";

export type GetEvidenceProgressResponse = EvidenceProgress[];

export type GetEvidenceProgressFn = () => Promise<GetEvidenceProgressResponse>;

const getEvidenceProgress: GetEvidenceProgressFn = async () => {
  return await httpGet(`/evidence-progress`);
};

export const EvidenceProgressAPI = {
  get: getEvidenceProgress,
};
